import { gsap } from 'gsap';
import '../css/styles.css';

// WooCommerce Products functionality
import { initProductTabs, initProductFaqAccordion } from './modules/woocommerce-products';

// Product tabs and FAQ functionality
import ProductTabs from './modules/product-tabs';

// Wishlist functionality  
import { initWishlistButtons, initWishlistPage, updateWishlistCount } from './modules/wishlist';

// Google Reviews functionality
import { initGoogleReviews } from './modules/google-reviews';

// Viewport animations functionality
import { initViewportAnimations } from './modules/viewport-animations/index';

// Partners slider functionality
import { initPartnersSliders } from './modules/partners-slider';

// Products slider functionality
import { initProductsSliders } from './modules/products-slider';

// Testimonials slider functionality
import { initTestimonialsSliders } from './modules/testimonials-slider';

// Category Testimonials slider functionality
import { initCategoryTestimonialsSliders } from './modules/category-testimonials-slider';

// Individuals slider functionality
import IndividualsSlider from './modules/individuals-slider';

// Product gallery functionality
import { initProductGallery } from './modules/product-gallery';

// Product quantity functionality
import { initProductQuantity } from './modules/product-quantity';

// Cart quantity functionality
import { initCartQuantity } from './modules/cart-quantity';


// Newsletter functionality
import { initNewsletterForm } from './modules/newsletter';

// Shop filters functionality
import { initShopFilters } from './modules/shop-filters';

// History component functionality
import { initHistoryComponent } from './modules/history';

// FAQ Accordion functionality
import { initFaqAccordions } from './modules/faq-accordion';

// Account Form Tabs functionality
import AccountFormManager from './modules/account-form-tabs';

document.addEventListener('DOMContentLoaded', function() {
   console.log('🔧 Webpack entry file loaded');
   
   // Initialize Viewport Animations
   initViewportAnimations();
   
   // Initialize WooCommerce products features
   if (document.querySelector('.product-additional-info-tabs, .faq-question-button')) {
      initProductTabs();
      initProductFaqAccordion();
      console.log('✅ WooCommerce products initialized');
   }
   
   // Initialize Wishlist
   if (document.querySelector('.wishlist-button')) {
      initWishlistButtons();
      initWishlistPage();
      updateWishlistCount();
   }
   
   // Initialize Google Reviews
   if (document.querySelector('.google-reviews-component')) {
      initGoogleReviews();
   }
   
   // Initialize Partners sliders
   if (document.querySelector('.partners-slider-container')) {
      initPartnersSliders();
   }
   
   // Initialize Products sliders
   if (document.querySelector('.products-slider')) {
      initProductsSliders();
   }
   
   // Initialize Testimonials sliders
   if (document.querySelector('[data-testimonials-carousel]')) {
      initTestimonialsSliders();    
   }

   // Initialize Category Testimonials sliders
    if (document.querySelector('[data-category-testimonials-carousel]')) {
        initCategoryTestimonialsSliders();
    }

   // Initialize Individuals sliders
   if (document.querySelector('.individuals-carousel')) {
      document.querySelectorAll('.individuals-carousel').forEach(carousel => {
         new IndividualsSlider(carousel);
      });
   }
   
   // Initialize Product Gallery
   if (document.querySelector('[data-product-gallery]')) {
      initProductGallery();
   }
   
   // Initialize Product Quantity
   if (document.querySelector('[data-quantity-input], [data-total-price]')) {
      initProductQuantity();
   }

   // Initialize Cart Quantity
    if (document.querySelector('.woocommerce-cart-form')) {
        initCartQuantity();
    }
   
   // Initialize Product Tabs and FAQ
   if (document.querySelector('.product-tabs')) {
      new ProductTabs();
   }
   
   // Initialize Newsletter form
   if (document.getElementById('newsletter-form')) {
      initNewsletterForm();
   }
   
   // Initialize Shop Filters
   if (document.querySelector('.shop-filters')) {
      initShopFilters();     
   }

   // Initialize History component
   initHistoryComponent();

   // Initialize FAQ Accordions
   if (document.querySelector('.faq-accordion')) {
      initFaqAccordions();
   }

   // Initialize Account Form Manager
   if (document.getElementById('form-switcher')) {
      new AccountFormManager();
   }

});
